<div id="change-password">
  <div id="change-password-form-wrapper" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

    <div fxLayout="column" fxLayoutAlign="bottom center">
      <div fxLayout="column" fxLayoutAlign="center start">
        <img class="logo" src="assets/images/logos/artstuff.svg">
        <img src="assets/images/logos/portal.svg">
      </div>
      <div class="font-size-24 text-bold mt-36">
        <span>{{ 'CHANGE_PASSWORD_VIEW.TITLE' | translate }}</span>
      </div>
    </div>

    <!-- error when change password fail   -->
    <div class="pl-20 pr-4">
      <div *ngIf="changePasswordErrorCode" fxLayout="row" class="mt-16 warning" [@animate]="{ value: '*', params: { delay: '100ms'} }">
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-icon>warning</mat-icon>
        </div>
        <span class="ml-16 white-space--pre-wrap">{{ 'CHANGE_PASSWORD_VIEW.ERROR_CODES.' + changePasswordErrorCode | translate }}</span>
      </div>
    </div>

    <div fxLayout="column" fxLayoutAlign="bottom center">
    <div [ngClass]="{'mt-24': !changePasswordErrorCode, 'mt-8': changePasswordErrorCode, 'pl-28 pr-12': true}">
      <ul class="mt-0 mb-0 pl-0">
        <li>{{ 'CHANGE_PASSWORD_VIEW.SUGGESTION.LENGTH' | translate }}</li>
        <li>{{ 'CHANGE_PASSWORD_VIEW.SUGGESTION.SECURITY' | translate }}</li>
      </ul>
    </div>
      <form *ngIf="changePasswordForm != null" class="mt-32" name="changePasswordForm" [formGroup]="changePasswordForm" novalidate fxLayout="column">
        <!-- old password -->
        <mat-form-field appearance="outline">
          <mat-label>{{'CHANGE_PASSWORD_VIEW.OLD_PASSWORD' | translate }}</mat-label>
          <input matInput formControlName="oldPassword" required [type]="hideOldPassword ? 'password' : 'text'">
          <mat-icon class="artstuff-pointer" [ngClass]="{'color--grey': hideOldPassword}" matSuffix (click)="toggleHideOldPassword()">{{hideOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error *ngIf="changePasswordForm.get('oldPassword').hasError('required')">
            {{'CHANGE_PASSWORD_VIEW.VALIDATION.OLD_PASSWORD_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <!-- new password -->
        <mat-form-field appearance="outline">
          <mat-label>{{'CHANGE_PASSWORD_VIEW.NEW_PASSWORD' | translate }}</mat-label>
          <input matInput formControlName="newPassword" required [type]="hideNewPassword ? 'password' : 'text'" [errorStateMatcher]="confirmPasswordStateMatcher">
          <mat-icon class="artstuff-pointer" [ngClass]="{'color--grey': hideNewPassword}" matSuffix (click)="toggleHideNewPassword()">{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error *ngIf="newPassWordErrorName()">
            {{'CHANGE_PASSWORD_VIEW.VALIDATION.NEW_PASSWORD_' + newPassWordErrorName() | translate }}
          </mat-error>
        </mat-form-field>

        <!-- confirm new password -->
        <mat-form-field appearance="outline">
          <mat-label>{{'CHANGE_PASSWORD_VIEW.CONFIRM_NEW_PASSWORD' | translate }}</mat-label>
          <input matInput formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'" [errorStateMatcher]="confirmPasswordStateMatcher">
          <mat-icon class="artstuff-pointer" [ngClass]="{'color--grey': hideConfirmPassword}" matSuffix (click)="toggleHideConfirmPassword()">{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error *ngIf="confirmPassWordErrorName()">
            {{'CHANGE_PASSWORD_VIEW.VALIDATION.CONFIRM_PASSWORD_' + confirmPassWordErrorName() | translate }}
          </mat-error>
        </mat-form-field>

        <!-- change password button -->
        <div class="mt-12 footer" fxLayout="row" fxLayoutAlign="center center">
            <button mat-raised-button color="accent" class="submit-button" aria-label="LOG IN"
                [disabled]="changePasswordForm.invalid" (click)="onChangePasswordClick()">
                {{'CHANGE_PASSWORD_VIEW.ACTION.SAVE_CHANGE' | translate }}
            </button>
            <button mat-button class="close-button ml-16" (click)="dialogRef.close()" matTooltip="Close" aria-label="Close">
                {{'CHANGE_PASSWORD_VIEW.ACTION.CLOSE' | translate }}
            </button>
        </div>

      </form>
    </div>

    </div>
</div>
